import { flatten, uniq } from 'lodash';
import { getTotalPages } from '../../../pagination_helpers';
import { BRAND_NEW } from '@reverbdotcom/commons/src/condition_helpers';
import { allSelectedFacets } from './facet';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

export function filterReturnPolicyListingIds(listings) {
  return (
    listings.filter(listing => {
      if (listing.soldAsIs) { return false; }
      const returnPolicyDays = listing.condition.conditionSlug === BRAND_NEW ?
        listing.shop?.returnPolicy?.newReturnWindowDays
        : listing.shop?.returnPolicy?.usedReturnWindowDays;
      return !!returnPolicyDays && returnPolicyDays >= 14;
    }).map(l => l.id)
  );
}

export function listingsSignals(listings) {
  const signals = listings?.map(listing => listing?.signals?.map(signal => signal.name));
  const formattedSignals = uniq(flatten(signals)).join('|');
  return formattedSignals;
}

export function formattedFilters(facetGroups) {
  const allSelected = allSelectedFacets(facetGroups);
  return allSelected.map(facet => `${facet.key}:${facet.paramValue}`).join('|');
}

export function trackingData(url, marketplaceListingsSearch, querySuggestionsResponse, listViewEnabled) {
  const { queryInfo, adjustedSearchUrl, listings, pagination, results } = marketplaceListingsSearch ?? {};
  const freeShippingListingIds = listings?.filter(listing => listing.shipping?.shippingPrices?.[0]?.rate?.amountCents === 0).map(l => l.id) || [];
  const returnPolicyListingIds = filterReturnPolicyListingIds(listings || []);

  return {
    autodirected: !!adjustedSearchUrl,
    category: url?.query?.category || '',
    correctedFrom: queryInfo?.rewritten ? queryInfo.originalQuery : '',
    correctedTo: queryInfo?.rewritten ? queryInfo.executedQuery : '',
    distance: url?.query?.distance || '',
    esScores: results?.map(result => result.score) || [],
    filter: formattedFilters(marketplaceListingsSearch?.facetInfo?.facetGroups || []),
    freeShippingListingIds: freeShippingListingIds,
    listingIds: listings?.map(listing => listing._id) || [],
    listingsCount: pagination?.total || 0,
    make: url?.query?.make || '',
    page: pagination?.page || 1,
    pageName: MParticlePageName.MarketplaceV2,
    postalCode: url?.query?.postal_code || '',
    productType: url?.query?.product_type || '',
    query: url.query?.query || '',
    querySuggestion: (querySuggestionsResponse?.querySuggestions?.queries?.[0]?.suggestions ?? [])[0],
    refererSlug: url?.query?.referer_slug || '',
    relatedSearchCount: querySuggestionsResponse?.querySuggestions?.queries?.[0]?.suggestions?.length || 0,
    returnPolicyListingIds: returnPolicyListingIds,
    signals: listingsSignals(listings || []),
    sort: url.query?.sort || '',
    totalPages: getTotalPages((pagination?.total || 0), (pagination?.pageSize || 45)),
    view: listViewEnabled ? 'List' : 'Grid',
  };
}
